import { Box } from "../../box";
import { forwardRef, useMemo } from "react";
import { createSizeAdapter, cssModule, mergeProps, normalizeSize, slot, useMergedRefs, useSlots } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { embeddedIconSize } from "../../icons";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "span";

/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */
const textSize = createSizeAdapter({
  "sm": "xs",
  "md": "sm"
});
/* eslint-enable sort-keys, sort-keys-fix/sort-keys-fix */

export function InnerLozenge({
  as = DefaultElement,
  children,
  variant,
  forwardedRef,
  size,
  ...rest
}) {
  const sizeValue = useResponsiveValue(size);
  const ref = useMergedRefs(forwardedRef);
  const {
    icon,
    text
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Text
    },
    icon: {
      className: "o-ui-lozenge-icon",
      size: embeddedIconSize(sizeValue)
    },
    text: {
      className: "o-ui-lozenge-text",
      size: textSize(sizeValue)
    }
  }), [sizeValue]));
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-lozenge", variant, icon && "has-icon", normalizeSize(sizeValue)),
      ref
    }),
    children: [icon, text]
  });
}
InnerLozenge.defaultElement = DefaultElement;
export const Lozenge = slot("lozenge", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerLozenge, { ...props,
  forwardedRef: ref
})));